import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const ApiAssetsSection = styled.div.attrs({ className: "brand-panel-muted" })``;

export const ApiAssetsEyebrowText = styled.p.attrs({
  className: "mt-3 text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const ApiAssetsLabelText = styled.p.attrs({
  className: "mt-1 text-sm font-medium text-[var(--brand-ink)]",
})``;

export const ApiAssetsSectionSecondary = styled.div.attrs({
  className: "brand-panel-muted md:col-span-3",
})``;

export const ApiAssetsEyebrowTextSecondary = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const ApiAssetsTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const ApiAssetsGridLayout = styled.div.attrs({ className: "grid gap-4" })``;

export const ApiAssetsHeaderRow = styled.div.attrs({
  className: "flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between",
})``;

export const ApiAssetsContentStack = styled.div.attrs({ className: "space-y-2" })``;

export const ApiAssetsEyebrowTextTertiary = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const ApiAssetsBodyText = styled.p.attrs({
  className: "text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const ApiAssetsFilterButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center rounded-full border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-2 text-center text-xs font-semibold uppercase tracking-[0.18em] text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] hover:text-[var(--brand-highlight)] sm:w-auto",
})``;

export const ApiAssetsSectionTertiary = styled.div.attrs({
  className: "mt-4 flex flex-wrap gap-2",
})``;

export const ApiAssetsStatusBadge = styled.span.attrs({
  className:
    "inline-flex items-center gap-2 rounded-full border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3 py-1.5 text-xs text-[var(--brand-muted)]",
})``;

export const ApiAssetsInlineText = styled.span.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const ApiAssetsGridLayoutSecondary = styled.div.attrs({
  className:
    "brand-panel-muted grid gap-3 sm:grid-cols-[minmax(0,1fr)_minmax(0,220px)] xl:grid-cols-[minmax(0,1fr)_220px]",
})``;

export const ApiAssetsFieldLabel = styled.label.attrs({ className: "grid gap-2" })``;

export const ApiAssetsInlineTextSecondary = styled.span.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-muted)]",
})``;

export const ApiAssetsFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const ApiAssetsSectionQuaternary = styled.div.attrs({ className: "flex flex-wrap gap-2" })``;

export const ApiAssetsPanelCard = styled.div.attrs({
  className:
    "overflow-hidden rounded-[22px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_16px_24px_rgba(0,0,0,0.18)]",
})``;

export const ApiAssetsSectionBody = styled.div.attrs({
  className:
    "flex h-40 items-center justify-center bg-[var(--brand-bg)] px-4 text-center text-sm text-[var(--brand-muted)]",
})``;

export const ApiAssetsContentStackSecondary = styled.div.attrs({ className: "space-y-3 p-4" })``;

export const ApiAssetsSectionQuinary = styled.div.attrs({
  className: "flex flex-col items-start gap-3 sm:flex-row sm:items-start sm:justify-between",
})``;

export const ApiAssetsContentStackTertiary = styled.div.attrs({ className: "min-w-0 space-y-1" })``;

export const ApiAssetsBodyTextSecondary = styled.p.attrs({
  className: "break-words font-medium leading-6 text-[var(--brand-ink)]",
})``;

export const ApiAssetsMetaText = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const ApiAssetsBodyTextTertiary = styled.p.attrs({
  className: "break-words text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const ApiAssetsInfoRow = styled.div.attrs({
  className: "flex flex-wrap items-center gap-2",
})``;

export const ApiAssetsActionLink = styled.a.attrs({
  className:
    "inline-flex max-w-full flex-wrap items-center gap-2 text-sm font-medium text-[var(--brand-highlight)]",
})``;

export const ApiAssetsInlineTextTertiary = styled.span.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const ApiAssetsPrimaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[var(--brand-highlight)] px-4 py-3 text-sm font-medium text-[#1b1306] transition hover:bg-[var(--brand-accent-deep)] hover:text-white sm:w-auto",
})``;

export const ApiAssetsInfoRowSecondary = styled.div.attrs({
  className: "flex items-center gap-3",
})``;

export const ApiAssetsSectionSenary = styled.div.attrs({ className: "h-12 w-12 shrink-0" })``;

export const ApiAssetsThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const ApiAssetsPanelCardSecondary = styled.div.attrs({
  className:
    "flex h-12 w-12 items-center justify-center rounded-2xl bg-[var(--brand-bg)] px-1 text-center text-xs uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const ApiAssetsTextGroup = styled.div.attrs({ className: "min-w-0" })``;

export const ApiAssetsLabelTextSecondary = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const ApiAssetsMetaTextSecondary = styled.p.attrs({
  className: "truncate text-xs text-[var(--brand-muted)]",
})``;

export const ApiAssetsGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-3 md:grid-cols-2 xl:grid-cols-4",
})``;

export const DocumentStatsStrip = styled.div.attrs({
  className: "grid grid-cols-2 gap-2 sm:grid-cols-4",
})``;

export const DocumentStatCard = styled.div.attrs({
  className:
    "rounded-xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-3 py-2.5",
})``;

export const DocumentStatLabel = styled.p.attrs({
  className: "text-[11px] font-medium uppercase tracking-[0.14em] text-[var(--brand-muted)]",
})``;

export const DocumentStatValue = styled.p.attrs({
  className: "mt-1 text-xl font-semibold tabular-nums leading-none text-[var(--brand-ink)]",
})``;

export const ApiAssetsEyebrowTextQuaternary = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-muted)]",
})``;

export const ApiAssetsBodyTextQuaternary = styled.p.attrs({
  className: "font-display mt-2 text-2xl font-semibold leading-tight text-[var(--brand-ink)]",
})``;

export const ApiAssetsBodyTextQuinary = styled.p.attrs({
  className: "mt-2 text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const ApiAssetsStatusBadgeSecondary = styled.span.attrs({
  className:
    "inline-flex items-center gap-2 rounded-full border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3 py-1.5 text-xs text-[var(--brand-muted)]",
})``;

export const ApiAssetsContentStackQuaternary = styled.div.attrs({ className: "space-y-1" })``;

export const ApiAssetsActionLinkSecondary = styled.a.attrs({
  className:
    "inline-flex max-w-full flex-wrap items-center gap-2 font-medium text-[var(--brand-ink)] transition hover:text-[var(--brand-highlight)]",
})``;

export const ApiAssetsSecondaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs font-medium text-emerald-700 transition hover:bg-emerald-100 sm:w-auto",
})``;

export const GalleryModeToggle = styled.div.attrs({
  className:
    "inline-flex w-full rounded-xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] p-1 sm:w-auto",
})``;

export const GalleryModeButton = styled.button.attrs<{ $active?: boolean }>(({ $active }) => ({
  className: `flex-1 rounded-lg px-3 py-2 text-xs font-medium transition sm:flex-none ${
    $active
      ? "bg-[var(--brand-accent)] text-white"
      : "text-[var(--brand-muted)] hover:text-[var(--brand-ink)]"
  }`,
}))<{ $active?: boolean }>``;

export const GalleryToolbar = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-[minmax(0,1fr)_minmax(0,200px)]",
})``;

export const GalleryFilterRow = styled.div.attrs({
  className: "flex flex-wrap gap-2",
})``;

export const GalleryFilterChip = styled.button.attrs<{ $active?: boolean }>(({ $active }) => ({
  className: `inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-xs font-medium transition ${
    $active
      ? "border-[var(--brand-highlight)] bg-[var(--brand-highlight)]/12 text-[var(--brand-highlight)]"
      : "border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] text-[var(--brand-muted)] hover:border-[var(--brand-highlight)]/45 hover:text-[var(--brand-ink)]"
  }`,
}))<{ $active?: boolean }>``;

export const GalleryFilterCount = styled.span.attrs({
  className: "tabular-nums opacity-80",
})``;

export const GalleryTileGrid = styled.div.attrs<{ $maxColumns?: 2 | 3 }>(({ $maxColumns }) => ({
  className:
    $maxColumns === 2
      ? "grid gap-3 sm:grid-cols-2"
      : "grid gap-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4",
}))<{ $maxColumns?: 2 | 3 }>``;

export const GalleryTile = styled.button.attrs<{ $quiet?: boolean }>(({ $quiet }) => ({
  className: `group relative overflow-hidden rounded-2xl border text-left transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-highlight)] ${
    $quiet
      ? "border-[var(--brand-border)]/70 bg-[rgba(255,255,255,0.02)] hover:border-[var(--brand-border)]"
      : "border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] hover:border-[var(--brand-highlight)]/50"
  }`,
}))<{ $quiet?: boolean }>``;

export const GalleryTileMedia = styled.div.attrs({
  className: "relative aspect-[4/3] w-full overflow-hidden bg-[var(--brand-bg)]",
})``;

export const GalleryTileMediaQuiet = styled.div.attrs({
  className:
    "relative flex aspect-[4/3] w-full flex-col items-center justify-center gap-2 bg-[rgba(255,255,255,0.02)] px-4 text-center",
})``;

export const GalleryTileOverlay = styled.div.attrs({
  className:
    "pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-[rgba(4,6,9,0.88)] via-[rgba(4,6,9,0.45)] to-transparent px-3 pb-3 pt-10 opacity-100 transition sm:opacity-0 sm:group-hover:opacity-100 sm:group-focus-visible:opacity-100",
})``;

export const GalleryTileTitle = styled.p.attrs({
  className: "truncate text-sm font-medium text-white",
})``;

export const GalleryTileCaption = styled.p.attrs({
  className: "mt-0.5 line-clamp-1 text-xs text-white/70",
})``;

export const GalleryTileFeatured = styled.span.attrs({
  className:
    "absolute right-2 top-2 z-[1] inline-flex h-7 w-7 items-center justify-center rounded-full border border-[var(--brand-highlight)]/40 bg-[rgba(4,6,9,0.65)] text-[var(--brand-highlight)]",
})``;

export const GalleryTilePlay = styled.span.attrs({
  className:
    "absolute left-1/2 top-1/2 z-[1] flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-white/25 bg-[rgba(4,6,9,0.55)] text-white backdrop-blur-sm transition group-hover:scale-105",
})``;

export const GalleryTileKindHint = styled.span.attrs({
  className: "text-[11px] uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const GalleryTileQuietTitle = styled.p.attrs({
  className: "line-clamp-2 text-sm text-[var(--brand-ink)]",
})``;

export const GalleryLightboxOverlay = styled.button.attrs({
  className: "fixed inset-0 z-[200] h-[100dvh] w-screen cursor-default bg-[rgba(4,6,9,0.88)] backdrop-blur-sm",
  type: "button",
  "aria-label": "Close lightbox",
})``;

export const GalleryLightboxShell = styled.div.attrs({
  className:
    "fixed inset-0 z-[210] flex h-[100dvh] w-screen items-center justify-center p-3 sm:p-6",
})``;

export const GalleryLightboxPanel = styled.div.attrs({
  className:
    "relative flex max-h-[min(92dvh,920px)] w-full max-w-5xl flex-col overflow-hidden rounded-2xl border border-[var(--brand-border)] bg-[rgba(12,16,22,0.98)] shadow-[0_24px_64px_rgba(0,0,0,0.45)]",
})``;

export const GalleryLightboxHeader = styled.div.attrs({
  className:
    "flex shrink-0 items-start justify-between gap-3 border-b border-[var(--brand-border)] px-4 py-3 sm:px-5",
})``;

export const GalleryLightboxBody = styled.div.attrs({
  className:
    "relative flex min-h-0 flex-1 items-center justify-center overflow-hidden bg-[rgba(0,0,0,0.35)] px-3 py-4 sm:px-6",
})``;

export const GalleryLightboxFooter = styled.div.attrs({
  className:
    "flex shrink-0 flex-col gap-3 border-t border-[var(--brand-border)] px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-5",
})``;

export const GalleryLightboxNavButton = styled.button.attrs({
  className:
    "absolute top-1/2 z-[2] flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-[var(--brand-border)] bg-[rgba(4,6,9,0.7)] text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:text-[var(--brand-highlight)] disabled:cursor-not-allowed disabled:opacity-30",
})``;

export const GalleryLightboxImage = styled.img.attrs({
  className: "max-h-full max-w-full object-contain",
})``;

export const GalleryLightboxVideo = styled.video.attrs({
  className: "max-h-full max-w-full",
  controls: true,
})``;

export const GalleryLightboxDocPanel = styled.div.attrs({
  className:
    "flex max-w-md flex-col items-center gap-3 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-6 py-8 text-center",
})``;

export const GalleryLightboxMediaFrame = styled.div.attrs({
  className: "flex h-full min-h-[240px] w-full max-h-[min(70dvh,640px)] items-center justify-center",
})``;
